import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const Hero = () => {
	const [showText, setShowText] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		// Show text after a short delay for video to start
		const timer = setTimeout(() => {
			setShowText(true);
		}, 1000); // 1 second delay for YouTube to start

		return () => clearTimeout(timer);
	}, []);

	return (
		<section id="home" className="relative min-h-screen flex flex-col">
			{/* Video Background */}
			<div className="absolute inset-0 z-0 w-full h-full">
				<video
					autoPlay
					muted
					loop
					playsInline
					className="absolute inset-0 w-full h-full object-cover object-center"
				>
					<source
						src="/assets/Videos/Swift-Hero-2.mp4"
						type="video/mp4"
					/>
				</video>
				{/* Overlay for better text readability */}
				<div className="absolute inset-0 bg-black bg-opacity-40"></div>

				{/* Gradient Transition Overlay */}
				{/* <div className="absolute inset-0 bg-gradient-to-t from-gray-50 via-transparent to-transparent z-10"></div> */}
			</div>

			{/* Header */}
			<Header className="mt-16" />

			{/* Content */}
			<div className="flex-1 flex items-center justify-center relative z-10 px-6 py-8 sm:py-0">
				<div className="container">
					<div
						className={`transition-opacity duration-1000 ${
							showText ? "opacity-100" : "opacity-0"
						}`}
					>
						<h1
							className={`text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-3 leading-tight transition-all duration-1000 font-generalSans ${
								showText
									? "translate-x-0 opacity-100"
									: "translate-x-full opacity-0"
							}`}
							style={{
								transitionDelay: showText ? "0.1s" : "0s",
							}}
						>
							<div className="relative">
								<div className="text-white">Say No</div>
								<div className="absolute font-light text-swift-pink font-catleya text-5xl sm:text-7xl lg:text-7xl xl:text-8xl top-0 sm:-top-3 lg:top-0 left-[7rem] sm:left-[13rem] md:left-[8rem] lg:left-[13rem] xl:left-[13rem]">
									to
								</div>
								<div className="text-white">Period Poverty</div>
							</div>
						</h1>

						<p
							className={`text-base sm:text-l lg:text-l text-white/90 leading-relaxed mb-6 sm:mb-8 max-w-2xl transition-all duration-1000 font-generalSans font-light ${
								showText
									? "translate-y-0 opacity-100"
									: "translate-y-8 opacity-100"
							}`}
							style={{
								transitionDelay: showText ? "0.3s" : "0s",
							}}
						>
							<span className="text-swift-pink pr-2">
								Welcome to Swift Haven!
							</span>
							We are building Africa's first community-powered{" "}
							<br className="hidden sm:block" />
							menstrual health network to fight period poverty and
							empower girls
						</p>

						<div
							className={`flex flex-col sm:flex-row gap-4 sm:gap-6 lg:gap-8 items-start transition-all duration-1000 ${
								showText
									? "translate-y-0 opacity-100"
									: "translate-y-8 opacity-0"
							}`}
							style={{
								transitionDelay: showText ? "0.6s" : "0s",
							}}
						>
							<a
								href="#contact"
								className="bg-swift-pink hover:bg-swift-pink/80 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full transition-colors duration-300 font-light text-sm sm:text-base lg:text-l font-generalSans"
							>
								Join Us Today!
							</a>

							<button
								onClick={() => navigate("/about")}
								className="text-white hover:text-swift-pink transition-colors duration-300 font-light text-sm sm:text-base lg:text-l mt-2 font-generalSans"
							>
								Learn More
							</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Hero;
